import { gql } from "@apollo/client";

export const GET_VALIDAR_INSUMO_PAGINATED = gql`
query GetAllValidarInsumo(
    $skip: Int
    $take: Int
    $where: t_InsumoFilterInput  
    $order : [t_InsumoSortInput!] 
) {
    allValidarInsumo(skip: $skip, take: $take, where: $where, order: $order )
    {
        items {
        idInsumoN,
        idInsumo,
        descripcion,
        descripcionGenerica,
        validado,
        activo
        }
        pageInfo {
            hasNextPage
            hasPreviousPage
        }
        totalCount
    }
}`;